import { useMemo } from "react";
import { OrganizationTaskTemplateStatusFilter } from "@common/schemas/organization-task-template.schema";
import { useOrganizationTaskTemplates } from "@api/organizationTaskTemplate.api";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { LocalTask } from "./closeTemplateTasksDrawer.types";

export const useOutdatedTemplateTaskIds = (
    localTasks: readonly LocalTask[],
): Set<string> => {
    const { closeManagement: isCloseManagementEnabled } = useTypedFlags();
    const { data: orgTaskTemplates } = useOrganizationTaskTemplates({
        status: OrganizationTaskTemplateStatusFilter.ALL,
        isEnabled: isCloseManagementEnabled,
    });

    return useMemo(() => {
        const latestVersionById = new Map(
            (orgTaskTemplates ?? []).map((template) => [
                template.id,
                template.version,
            ]),
        );
        return new Set(
            localTasks
                .filter((task) => {
                    if (
                        task.isDeleted ||
                        !task.sourceTemplateId ||
                        task.sourceTemplateVersion === null
                    ) {
                        return false;
                    }
                    const latestVersion = latestVersionById.get(
                        task.sourceTemplateId,
                    );
                    return (
                        latestVersion !== undefined &&
                        latestVersion > task.sourceTemplateVersion
                    );
                })
                .map((task) => task.localId),
        );
    }, [localTasks, orgTaskTemplates]);
};
